import {
  isLocalhost,
  isNitroEnvironment,
} from 'module/helpers/environment-type';
import { datadogLogs, StatusType } from '@datadog/browser-logs';
import { datadogRum } from '@datadog/browser-rum';
import LogRocket from 'logrocket';
import { typecastError } from './error';

const _log =
  (status: StatusType) =>
  (message: string, context?: Record<string, unknown> | any) => {
    datadogLogs.logger.log(message, context, status);
    if (isLocalhost() || isNitroEnvironment()) {
      // eslint-disable-next-line no-console
      console[status](message, context);
    }
  };

const log = _log('info');
const info = _log('info');
const warn = _log('warn');
const debug = _log('debug');
const _error = _log('error');
const error = (
  message: string,
  { error: err, ...context }: { error: unknown } & Record<string, unknown>,
) => {
  const reason = typecastError(err);

  reason.message = message;

  _error(message, context);
  datadogRum.addError(reason, context);
  LogRocket.captureException(reason, {
    extra: {
      pageUrl: window.location.href,
      info: JSON.stringify(context.info),
    },
  });
};

export const logger = {
  log,
  info,
  warn,
  debug,
  error,
};
export { typecastError } from './error';
